import React from "react";
import { graphql, useFragment } from "react-relay";
import { ProductDetailComponent } from "./ProductDetails";
import { ProductInfoComponentDetail_ProductInfoComponentDetailSchema$key } from "./__generated__/ProductInfoComponentDetail_ProductInfoComponentDetailSchema.graphql";
import { ScrollView } from "react-native";

export function ProductInfoComponentDetail(props: {
  component: ProductInfoComponentDetail_ProductInfoComponentDetailSchema$key;
}) {
  const productInfoComponentDetail = useFragment(
    graphql`
      fragment ProductInfoComponentDetail_ProductInfoComponentDetailSchema on ProductInfoComponentDetailSchema {
        components {
          __typename
          ...ProductDetailsComponent
        }
      }
    `,
    props.component
  );
  return (
    <ScrollView style={{ flex: 1 }}>
      {productInfoComponentDetail.components?.map((component, i, arr) => (
        <ProductDetailComponent
          component={component}
          key={i + ""}
          beforeHasSeparator={
            i === 0 || arr[i - 1].__typename === "ProductInfoSection"
          }
        />
      ))}
    </ScrollView>
  );
}
